export default class Star {
  private position: any
  private lifespan: number

  constructor(private p5: any, position: any) {
    this.position = position.copy()
    this.lifespan = 255.0
  }

  run() {
    this.update()
    this.display()
  }

  isDead(): boolean {
    return this.lifespan < 0
  }

  private update() {
    this.lifespan -= 2
  }

  private display() {
    this.p5.fill(200, 200, 200, this.p5.random(this.lifespan - 100, this.lifespan + 100))
    const size = this.p5.random(2, 8)
    this.p5.ellipse(this.position.x, this.position.y, size, size)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/graphics/Star.ts